import React, { Component } from 'react';
import Helmet from 'react-helmet';
import './contact.scss';

class ContactPage extends Component {
    constructor(props) {
        super(props);

        this.validate = this.validate.bind(this);
        this.validateItem = this.validateItem.bind(this);
    }

    validate(event) {
        try {
            if (!this.validateItem(event, 'first_name', 'Please enter First Name')) {
                return;
            }

            if (!this.validateItem(event, 'last_name', 'Please enter Last Name')) {
                return;
            }

            if (!this.validateItem(event, 'email', 'Please enter Email')) {
                return;
            }

            if (!this.validateItem(event, 'phone', 'Please enter Phone')) {
                return;
            }
        } catch (err) {
            console.error(err);
            event.preventDefault();
        }
    }
    
    validateItem(event, id, msg) {
        let elm = document.getElementById(id);
        if (elm.value == '') {
            let errorElm = document.getElementsByClassName('error-message')[0];
            errorElm.innerHTML = msg;
            elm.focus();
            event.preventDefault();
            return false;
        }

        return true;
    }


    render() {
        /*
                    <!--
                    <h2>
                        Office
                    </h2>
                    <div className="address">
                        <p>4900 Hopyard Rd</p>
                        <p>Pleasanton CA</p>
                    </div>
                    -->

        */
        return (
            <div className='contact-container'>
                <Helmet title={`Datasert - Contact Us`} />

                <div className='content'>
                    <h2>
                        Email
                    </h2>
                    <a href="mailto:support@datasert.com">support@datasert.com</a>

                    <h2>
                        Address
                    </h2>
                    <div>4900 Hopyard Road #100</div>
                    <div>Pleasanton CA 94588</div>

                    <h2>
                        Phone
                    </h2>
                    <div>973-752-5049</div>

                    <h2>
                        Have us reach you
                    </h2>
                    <div className="contact-form">
                        <form className="contact-form2" action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST" onSubmit={this.validate}>
                            <input type="hidden" name="oid" value="00Df4000001Qt1b" />
                            <input type="hidden" name="retURL" value="https://www.datasert.com/company/contact-thankyou" />

                            <label htmlFor="first_name">First Name <span className="required-dot">*</span></label><input id="first_name" maxLength="40" name="first_name" size="20" type="text" /><br />
                            <label htmlFor="last_name">Last Name <span className="required-dot">*</span></label><input id="last_name" maxLength="80" name="last_name" size="20" type="text" /><br />
                            <label htmlFor="email">Email <span className="required-dot">*</span></label><input id="email" maxLength="80" name="email" size="20" type="text" /><br />
                            <label htmlFor="phone">Phone <span className="required-dot">*</span></label><input id="phone" maxLength="40" name="phone" size="20" type="text" /><br />
                            <label htmlFor="company">Company</label><input id="company" maxLength="40" name="company" size="20" type="text" /><br />
                            <p className="error-message"/>
                            <input className="button-download-product" type="submit" name="submit" />
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactPage;


// WEBPACK FOOTER //
// ./src/pages/company/contact.jsx